import moment from "moment";
import { apiRexxbot } from "./apiRexxbot";
import { getCustomerPhone } from "./cartReminder";

const BRAZIL_DDI = "55";

/**
 * Normaliza o telefone para o formato esperado pela API: só dígitos, com DDI 55
 * e no máximo 20 caracteres.
 */
export function toWhatsappDigits(phone) {
	const digits = String(phone || "").replace(/\D/g, "");
	if (!digits) return "";

	const withDdi = digits.startsWith(BRAZIL_DDI) ? digits : `${BRAZIL_DDI}${digits}`;

	return withDdi.slice(0, 20);
}

export async function postPedidoAgendado({ cdEmpresa, date, time }) {
	try {
		const dataAgendada = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm");
		const telefone = toWhatsappDigits(await getCustomerPhone());
		if (!cdEmpresa || !telefone) return { ok: true, skipped: true };

		// nmCliente é obrigatório na API: sem nome cadastrado, usa um padrão.
		const nome = localStorage.getItem("@Inoveclube:userName") || "Cliente";

		const { data } = await apiRexxbot.post("/pedido-agendado", {
			telefone,
			nmCliente: nome.slice(0, 300),
			dataAgendada: dataAgendada.format("YYYY-MM-DD HH:mm:ss"),
			cdEmpresa,
		});

		return { ok: Boolean(data?.sucess), message: data?.message };
	} catch (error) {
		return {
			ok: false,
			message: error.response?.data?.message || "Erro ao criar pedido agendado.",
		};
	}
}
